import { render, staticRenderFns } from "./tab-1pmc.vue?vue&type=template&id=7a783e36&scoped=true&"
import script from "./tab-1pmc.vue?vue&type=script&lang=js&"
export * from "./tab-1pmc.vue?vue&type=script&lang=js&"
import style0 from "./tab-1pmc.vue?vue&type=style&index=0&id=7a783e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a783e36",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VIcon,VLayout,VSkeletonLoader,VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a783e36')) {
      api.createRecord('7a783e36', component.options)
    } else {
      api.reload('7a783e36', component.options)
    }
    module.hot.accept("./tab-1pmc.vue?vue&type=template&id=7a783e36&scoped=true&", function () {
      api.rerender('7a783e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/results-pages/tabs/tab-1pmc.vue"
export default component.exports